import axios from 'axios';
import cookies from 'js-cookie';
import { getUserKey } from './yUtil.js'

const userKey = getUserKey()
cookies.set('userKey', userKey)

const maxRetryTimes = 2
const request = async (args) => {
  const { url, data, params, method = 'GET', isOutOrigin = false } = args;

  let retryTimes = 0
  const instance = async () => {
    isOutOrigin && delete args.isOutOrigin;
    const res = isOutOrigin ? await axios(args): await axios({
      method,
      url,
      data,
      params,
      timeout: 3000
    })
  
    if (res.status === 200 || res.status === 201) {
      // 业务状态码交给业务处理
      return res.data
    } else {
      if (retryTimes < maxRetryTimes) {
        retryTimes++

        return instance()
      } else {
        throw new Error(`request failed, status: ${res.status}`)
      }
    }
  }

  return instance()
}
export default {
  get: (url = '', params = {}) => {
    return request({
      url,
      params
    })
  },
  post: (url, data = {}) => {
    return request({
      method: 'POST',
      url,
      data
    })
  },
  complicatedPost: (opt = {}) => {
    console.debug('axios debug', opt);
    return request(opt);
  }
}